import React from 'react';

const UserDetailCellRenderer = () => <h1 style={{ padding: '20px' }}>My Custom Detail</h1>;

export default UserDetailCellRenderer;